import * as tslib_1 from "tslib";
// PO31B
import React from 'react';
import { useTranslation } from 'react-i18next';
import Eclipse from '../Eclipse';
export var EclipseExplore = function (props) {
    var t = useTranslation().t;
    return (React.createElement(Eclipse, tslib_1.__assign({}, props, { title: t('welcomePopup.title'), text: t('welcomePopup.text') })));
};
EclipseExplore.displayName = 'EclipseExplore';
export default EclipseExplore;
//# sourceMappingURL=EclipseExplore.js.map